import { graphqlOperation } from "@aws-amplify/api";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";

// Workspace queries use Lambda auth for workspace validation
const getWorkspace = ({ id }) =>
  makeGraphQLRequest(
    graphqlOperation(queries.getWorkspace, { id })
  );

// getUsersWorkspace is a custom resolver - uses Lambda auth
const getWorkspaceUsers = (id, limit) =>
  makeGraphQLRequest(
    graphqlOperation(queries.getUsersWorkspace, { id, limit })
  );

// getPlanWorkspace is a custom resolver - uses Lambda auth
const getPlanWorkspace = (id) =>
  makeGraphQLRequest(
    graphqlOperation(queries.getPlanWorkspace, { id })
  );

export default {
  getWorkspace,
  getWorkspaceUsers,
  getPlanWorkspace,
};
